"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlaps = exports.simple = void 0;
exports.simple = [
    {
        span: {
            start: 118,
            end: 127,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            uuid: "blah1",
            confidence: 0.9900000000000001,
            diagnosis_code: "Q66.6",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 118,
            end: 149,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            uuid: "blah2",
            confidence: 0.9900000000000001,
            diagnosis_code: "R60.0",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 3,
            end: 26,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            uuid: "blah3",
            confidence: 0.9900000000000001,
            diagnosis_code: "V66.6",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 3,
            end: 19,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            uuid: "blah4",
            confidence: 0.9900000000000001,
            diagnosis_code: "R31.9",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 80,
            end: 99,
            content: "just a value",
            document_id: 234325
        },
        codeType: "cpt",
        code: {
            uuid: "blah5",
            confidence: 0.9900000000000001,
            diagnosis_code: "74174",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 91,
            end: 99,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            uuid: "blah6",
            confidence: 0.9900000000000001,
            diagnosis_code: "Q66.7",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 2982,
            end: 3028,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            uuid: "blah7",
            confidence: 0.9900000000000001,
            diagnosis_code: "Q66.6",
            evidence: []
        },
        active: false
    }
];
exports.overlaps = [
    {
        span: {
            start: 5,
            end: 15,
            content: "just a value",
            document_id: 234325
        },
        codeType: "icd",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "Q66.6",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 10,
            end: 20,
            document_id: 234325
        },
        codeType: "icd",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "R60.0",
            evidence: []
        },
        active: false
    },
    {
        span: {
            start: 12,
            end: 22,
            document_id: 234325
        },
        codeType: "icd",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "R60.0",
            evidence: []
        },
        active: false
    }
];
//# sourceMappingURL=unstructured-highlights.js.map